import { initializeApp } from 'firebase/app';
import {
  getAuth,
} from 'firebase/auth';

// OLD QA Test

// export const firebaseConfig = {

//   apiKey: "AIzaSyBNmM3TLA7s2nIbNhAaqdf2fU6ma1AVeCg",

//   authDomain: "martinrea-d4f81.firebaseapp.com",

//   projectId: "martinrea-d4f81",

//   storageBucket: "martinrea-d4f81.appspot.com",

//   messagingSenderId: "636066870447",

//   appId: "1:636066870447:web:be7370c09f12fceaf9105a"

// };

// // Test
export const firebaseConfig = {

  apiKey: "AIzaSyCtCG3-eNor_-DbrHttAfpR3mYb8dEIpYw",

  authDomain: "test-mplb.firebaseapp.com",

  projectId: "test-mplb",

  storageBucket: "test-mplb.appspot.com",

  messagingSenderId: "307309926275",

  appId: "1:307309926275:web:0cb210ed404fa9317a08b6",

  measurementId: "G-L587MBVXFH"

};
  // PROD


  // export const firebaseConfig = {

  //   apiKey: "AIzaSyBDkaIm41xR32CcukuHa7O_mx5pDUgLbi4",

  //   authDomain: "aws-mplb-prod.firebaseapp.com",

  //   projectId: "aws-mplb-prod",

  //   storageBucket: "aws-mplb-prod.appspot.com",

  //   messagingSenderId: "936162549755",

  //   appId: "1:936162549755:web:137e15ce64063a3da1b55e",

  //   measurementId: "G-5GN9LRDXZ9"
  // };
  
  //Old PROD
  // export const firebaseConfig = {

  //   apiKey: "AIzaSyCQof01_Ye5FZpA4n33c_gQ4M6M672lEjc",
  
  //   authDomain: "mplb-875f9.firebaseapp.com",
  
  //   projectId: "mplb-875f9",
  
  //   storageBucket: "mplb-875f9.appspot.com",
  
  //   messagingSenderId: "1088890335074",
  
  //   appId: "1:1088890335074:web:30876691d838e4d566863b"
  
  // };
  
  
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);